var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { width: "652px", margin: "0 auto" },
      attrs: { id: "template-one" },
    },
    [
      _c("div", { staticClass: "go-report-wrap" }, [
        _c(
          "div",
          {
            class: [
              _vm.selectedComponent === _vm.dataHeading.component
                ? "component_select"
                : "",
              "go-report-cover body_component",
            ],
            on: {
              click: function ($event) {
                return _vm.selectComponent(
                  _vm.dataHeading.component,
                  _vm.dataHeading.arrDocId
                )
              },
            },
          },
          [
            _c("div", { staticClass: "go-cover-text-wrap" }, [
              _c("h1", { staticClass: "go-cover-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.dataHeading.data.title.content) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-cover-image" }, [
              _vm.dataHeading.data.title_image &&
              _vm.dataHeading.data.title_image.content
                ? _c("img", {
                    attrs: { src: _vm.dataHeading.data.title_image.content },
                    on: {
                      error: function ($event) {
                        _vm.dataHeading.data.title_image.content =
                          "https://goover.ai:7999/thumbnail/insight-cover/def78006-f92b-47ea-8e5e-7fad428b9f78.png"
                      },
                    },
                  })
                : _c("img", {
                    attrs: {
                      src: "https://goover.ai:7999/thumbnail/insight-cover/def78006-f92b-47ea-8e5e-7fad428b9f78.png",
                    },
                  }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-cover-text-wrap" }, [
              _c("div", { staticClass: "go-cover-type" }, [
                _vm._v("Goover Daily Report"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-cover-date" }, [
                _vm._v(_vm._s(_vm.dataHeading.data.date.content)),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "go-cover",
            class: [
              _vm.selectedComponent === _vm.dataTableOfContent.component
                ? "component_select"
                : "",
              "go-report-toc body_component",
            ],
            on: {
              click: function ($event) {
                return _vm.selectComponent(
                  _vm.dataTableOfContent.component,
                  _vm.dataTableOfContent.arrDocId
                )
              },
            },
          },
          [
            _c("strong", [
              _vm._v(
                _vm._s(_vm.dataTableOfContent.data.table_of_section.content)
              ),
            ]),
            _vm._v(" "),
            _c(
              "ol",
              { staticClass: "go-report-list-decimal" },
              _vm._l(
                _vm.dataTableOfContent.data.table_of_entry,
                function (model, index) {
                  return _c("li", { key: index }, [
                    _vm._v(_vm._s(model.content)),
                  ])
                }
              ),
              0
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "go-report-contents" },
          [
            _vm._l(_vm.dataBody, function (model, index) {
              return _c("body-component", {
                key: index,
                attrs: {
                  option: model,
                  componentSelect: _vm.selectedComponent,
                  index: index,
                  bodyLength: _vm.dataBody.length,
                },
                on: { selectBody: _vm.selectBody },
              })
            }),
            _vm._v(" "),
            _c("reference-component", {
              attrs: {
                option: _vm.dataReference,
                index: _vm.dataBody.length || 0,
                componentSelect: _vm.selectedComponent,
              },
              on: { selectBody: _vm.selectBody },
            }),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }